import digitalLogo from "../assets/logos/digitalProf-it.png";
import federacionLogo from "../assets/logos/Federacion_Cafeteros.png";
import seguroslogo from "../assets/logos/seguros_bolivar.png";
import fabellalogo from "../assets/logos/falabella.png";
import horizonLogo from "../assets/logos/Horizon.png";
import nettoLogo from "../assets/logos/NETTO.png";
import impulsapLogo from "../assets/logos/impulsap.png";

export const businessThemes: Record<
  number,
  {
    navBackground: string;
    navTextColor: string;
    dropdownItemColor: string;
    logo: string;
    logoFilter?: string;
    logoMaxHeight?: string;
    iconColor: string;
    iconHoverColor: string;
    tooltipBackground: string;
    buttonPrimary: string;

  }
> = {
  1: {
    // DigitalProf-IT — Colores según Manual de Identidad
    // Tech Green: #9BDD33 | Deep Blue: #151D20

    // Components - BarraMenu
    // Fondo Deep Blue — versión lapicero del manual (logo blanco sobre oscuro)
    // IMPORTANTE: subir logo blanco como digitalProf-it-white.png y actualizar import
    navBackground: "linear-gradient(90deg, #0a0f0a 0%, #151D20 45%, #2a4a1e 75%, #4a7a28 100%)",
    navTextColor: "#ffffff",
    dropdownItemColor: "#151D20",
    logo: digitalLogo,
    logoFilter: undefined,
    logoMaxHeight: "38px",

    // Pages - LandingPage
    iconColor: "#151D20",          // Deep Blue para íconos de tarjetas
    iconHoverColor: "#9BDD33",     // Tech Green al hover
    tooltipBackground: "#151D20", // Deep Blue

    // Buttons
    buttonPrimary: "#9BDD33"       // Tech Green — acento principal

  },

  4: {
    // Federación Nacional de Cafeteros

    // Components - BarraMenu
    navBackground: "linear-gradient(135deg, #D3163B, #D3163B)",
    navTextColor: "#FFFFFF",
    dropdownItemColor: "#D3163B",
    logo: federacionLogo,
    logoMaxHeight: "40px",

    // Pages - LandingPage
    iconColor:"#80142D",
    iconHoverColor: "#D3163B",
    tooltipBackground: "#5A0F20",

    // Buttons
    buttonPrimary: "#D3163B"
  },
  3: {
    // Seguros Bolívar
    navBackground: "linear-gradient(135deg, #048451, #048451)",
    navTextColor: "#FFFFFF",
    dropdownItemColor: "#FFE16F",
    logo: seguroslogo,
    logoMaxHeight: "44px",

    // Pages - LandingPage
    iconColor:"#048451",
    iconHoverColor: "#FFE16F",
    tooltipBackground: "#048451",

    // Buttons
    buttonPrimary: "#FFD050"
  },
  5: {
    // falabella
    navBackground: "linear-gradient(135deg, #B6DE26, #B6DE26)",
    navTextColor: "#1E364B",
    dropdownItemColor: "#1E364B",
    logo: fabellalogo,
    logoMaxHeight: "40px",
    iconColor:"#1E364B",
    iconHoverColor: "#B6DE26",
    tooltipBackground: "#1E364B",
    buttonPrimary: "#B6DE26"
  },
  10: {
    // Netto
    navBackground: "linear-gradient(135deg, #1a1a2e, #1a1a2e)",
    navTextColor: "#FFFFFF",
    dropdownItemColor: "#FFFFFF",
    logo: nettoLogo,
    logoMaxHeight: "40px",
    iconColor: "#1a1a2e",
    iconHoverColor: "#e94560",
    tooltipBackground: "#1a1a2e",
    buttonPrimary: "#e94560"
  },
  12: {
    // Horizon
    navBackground: "linear-gradient(135deg, #003366, #003366)",
    navTextColor: "#FFFFFF",
    dropdownItemColor: "#FFFFFF",
    logo: horizonLogo,
    logoMaxHeight: "48px",
    iconColor: "#003366",
    iconHoverColor: "#0066cc",
    tooltipBackground: "#003366",
    buttonPrimary: "#0066cc"
  },
  19: {
    // Impulsap
    navBackground: "linear-gradient(135deg, #ff6600, #ff6600)",
    navTextColor: "#FFFFFF",
    dropdownItemColor: "#FFFFFF",
    logo: impulsapLogo,
    logoMaxHeight: "40px",
    iconColor: "#ff6600",
    iconHoverColor: "#ff8833",
    tooltipBackground: "#ff6600",
    buttonPrimary: "#ff6600"
  }
};